import React from 'react'
import styled from '@emotion/styled'
import {Color} from '../Styles'


const MBMemberRadioLabel = styled.label`
  position: relative;
  cursor: pointer;
`

const MBMemberRadioInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
`

const MBMemberRadioSpanAfterStyle = ({checked}: MBMemberRadioSpanProps): string | undefined => {
  return checked ? `
    &::after {
      position: absolute;
      top: 50%;
      left: 3px;
      display: block;
      width: 12px;
      height: 12px;
      margin-top: -6px;
      content: '';
      border-radius: 100%;
      background: ${Color.Black};
    }
  `
    : undefined
}

type MBMemberRadioSpanProps = Pick<MBMemberRadioProps,
  'checked' | 'disabled' | 'fontRemSize' | 'isBoldLabel' | 'hasError'>
const MBMemberRadioSpan = styled.span<MBMemberRadioSpanProps>`
  line-height: 1.625;
  display: inline-block;
  padding-left: 26px;
  background-color: ${Color.White};
  font-size: ${({fontRemSize}): number => fontRemSize ?? 1.3}rem;
  font-weight: ${({isBoldLabel}): string => isBoldLabel ? 'bold' : 'normal'};
  ${({disabled}): string | undefined => disabled ? `color: ${Color.Grey500};` : undefined}
  cursor: ${({disabled}): string => disabled ? 'default' : 'pointer'};

  &::before {
    position: absolute;
    top: 50%;
    left: 0;
    display: block;
    width: 18px;
    height: 18px;
    margin-top: -9px;
    content: '';
    border: solid 1px ${({hasError}): string => hasError ? Color.ErrorInputBorderColor : Color.Grey100};
    border-radius: 100%;
    background-color: ${({hasError}): string => hasError ? Color.ErrorInputBackgroundColor : Color.White};
  }

  ${MBMemberRadioSpanAfterStyle}
`

type MBMemberRadioProps = Pick<JSX.IntrinsicElements['input'],
  'id' |
  'name' |
  'value' |
  'disabled' |
  'onChange' |
  'checked' |
  'autoComplete'> & {
  labelName: string
  hasError?: boolean
  isBoldLabel?: boolean
  fontRemSize?: number
}

export const MBMemberRadio: React.VFC<MBMemberRadioProps> = (props) => {
  const {labelName, disabled, hasError, isBoldLabel, fontRemSize, ...rest} = props

  return (
    <MBMemberRadioLabel htmlFor={props.id}>
      <MBMemberRadioInput {...rest} type="radio" disabled={disabled}/>
      <MBMemberRadioSpan
        disabled={disabled}
        checked={props.checked}
        hasError={hasError}
        isBoldLabel={isBoldLabel}
        fontRemSize={fontRemSize}
      >{labelName}</MBMemberRadioSpan>
    </MBMemberRadioLabel>
  )
}
